/** Horizontal offset for popover alignment to match post left edge */
export const POPOVER_ALIGN_OFFSET = -24;

/** Vertical offset for popover positioning from trigger */
export const POPOVER_SIDE_OFFSET = 1;

/** Delay in milliseconds before showing the popover on hover */
export const POPOVER_HOVER_DELAY = 500;
